import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { PdfAuthorNote } from "./pdf-author-note"
import { getContentCellSx, sectionHeadingCellSx } from "./pdf-task-comparison-helpers"
import { PdfTaskChangeSummaryItem } from "./pdf-task-change-summary-item"
import { PdfTaskPanel } from "./pdf-task-panel"
import { TaskRowHeader } from "./task-row-header"
import { sanitizePdfHtml } from "./pdf-formatters"

export function PdfTaskRows({ item, showUnchangedNote }) {
    const label =
        `Task ${item.displayIndex ?? item.originalTask?.displayIndex ?? item.draftTask?.displayIndex ?? ""}`.trim()
    const shouldShowChangeSummary = item.status === "modified" && item.changeSummary?.length > 0
    const safeAuthorNote = buildSanitizedNote(item.note)
    const hasAuthorNote = Boolean(safeAuthorNote?.content)

    return (
        <>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <TaskRowHeader label={label} status={item.status} />
                </Box>
            </Box>
            <Box component="tr">
                <Box component="td" sx={getContentCellSx("left", item.status !== "unchanged")}>
                    <PdfTaskPanel
                        task={item.originalTask}
                        otherTask={item.draftTask}
                        status={item.status}
                        side="left"
                        showUnchangedNote={showUnchangedNote}
                    />
                </Box>
                <Box component="td" sx={getContentCellSx("right", item.status !== "unchanged")}>
                    <PdfTaskPanel
                        task={item.draftTask}
                        otherTask={item.originalTask}
                        status={item.status}
                        side="right"
                        showUnchangedNote={showUnchangedNote}
                    />
                </Box>
            </Box>
            <If value={shouldShowChangeSummary}>
                <Box component="tr">
                    <Box component="td" colSpan={2} sx={{ p: 0, pt: "12px" }}>
                        <Typography sx={{ fontWeight: 700, fontSize: "10px", color: "#374151", mb: "8px" }}>
                            TASK CHANGES
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={0}
                            sx={{
                                borderTop: "1px solid #d7dce2",
                                borderBottom: "1px solid #d7dce2",
                            }}
                        >
                            <Repeat list={item.changeSummary} item={<PdfTaskChangeSummaryItem />} />
                        </Stack>
                    </Box>
                </Box>
            </If>
            <If value={hasAuthorNote}>
                <Box component="tr" sx={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <Box
                        component="td"
                        colSpan={2}
                        sx={{ p: 0, pt: "10px", pb: "24px", pageBreakInside: "avoid", breakInside: "avoid" }}
                    >
                        <PdfAuthorNote note={safeAuthorNote} />
                    </Box>
                </Box>
            </If>
        </>
    )
}

function buildSanitizedNote(note) {
    if (!note) return note

    return {
        ...note,
        content: sanitizePdfHtml(note.content),
    }
}
